module.exports = __webpack_public_path__ + "static/media/VINNERS_RECIPT_LOGS.4f9f744d.jpg";